import React from 'react'
import Terms from '../../Componet/Terms'
import NewsletterL1 from '../../Componet/Newsletter/NewsletterL1'
import HerosectionHeader from '../../Componet/Herosection/HerosectionHeader'
import PrivateCloud1 from '../../Componet/Private_Cloud/PRIVATE_CLOUD1'


function TermsConditions() {
    return (
        <>
            <HerosectionHeader folder1={"pages"} folder2={"Utilities"} name={"Private Cloud"} />
            <div class="page-content">
                <PrivateCloud1></PrivateCloud1>
                <NewsletterL1 />
            </div>
        </>
    )
}

export default TermsConditions
